import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { tryToDeleteIntegration, tryToFetchIntegrations } from '../../../store/brokers/partner/integrations/IntegrationsSlice';
import { IPaginationPayload } from '../../../interfaces/shared/IPaginationPayload';
import { IToast } from '../../../interfaces/components/IToast';
import Toast from '../../../shared/toast';
import DeleteModal from '../../../shared/delete-modal';
import IntegrationsTable from './tables/IntegrationsTable';
import IntegrationDetailsModal from './modals/IntegrationDetailsModal';
import Button from '../../../shared/button';
import ManageIntegrationModal from './modals/ManageIntegrationsModal';


const Integrations = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [rows, setRows] = useState<any>();
    const [showToast, setShowToast] = useState<IToast | null>()
    const [showIntegrationModal, setShowIntegrationModal] = useState<{ show: boolean, data: any }>();
    const [showManageModal, setShowManageModal] = useState<{ show: boolean, id?: string, data?: any }>();
    const [showDeleteModal, setShowDeleteModal] = useState<{ show: boolean, id: string }>();
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const paginationData = useAppSelector((state) => state.integrations.integrations?.data?.page);
    const rowsLoading = useAppSelector((state) => state.integrations.integrationsAreLoading);
    const state = useAppSelector((state) => state.integrations);

    useEffect(() => {
        if (state.integrations) {
            const rows =
                state.integrations?.data?.elements && Array.isArray(state.integrations?.data.elements)
                    ? state.integrations?.data.elements.map((r: any) => ({ ...r, id: r._id }))
                    : [];
            setRows(rows);
        }
    }, [state.integrations]);

    const onGettingData = async () => {
        try {
            let data: any = { ...paginationState }
            await dispatch(tryToFetchIntegrations(data)).unwrap();
        } catch (err) {
            // err
        }
    }

    useEffect(() => {
        onGettingData();
    }, [paginationState]);

    const onGoBack = () => {
        navigate(-1)
    }

    const onSeeIntegrationDetails = async (data: any) => {
        setShowIntegrationModal({
            show: true,
            data: data
        })
        document.body.style.overflow = 'hidden';
    }

    const onSeeManageModal = async (id?: string, data?: any) => {
        setShowManageModal({
            show: true,
            id: id,
            data: data
        })
        document.body.style.overflow = 'hidden';
    }

    const onDeleteIntegration = async () => {
        try {
            await dispatch(tryToDeleteIntegration(showDeleteModal?.id || ''))
            setShowToast({ type: 'success', message: `Integration successfully deleted` });
        } catch (error) {
            setShowToast({ type: 'error', message: `${error}` });
        }
        setShowDeleteModal(undefined)
    }

    const onRequestDeleteIntegration = (id: string) => {
        setShowDeleteModal({ show: true, id })
    }

    const onCloseDeleteModal = () => {
        setShowDeleteModal(undefined)
    }

    const onSaveChanges = (type: string, message: string) => {
        setShowToast({ type, message })
    }

    const onCloseModal = () => {
        setShowIntegrationModal(undefined)
        setShowManageModal(undefined)
        document.body.style.overflow = 'auto';
    }

    return (
        <div>
            <div className={'flex flex-row items-center justify-between mb-10'}>
                <div className='flex flex-row items-center'>
                    <div onClick={onGoBack} className='md:-ml-2 xl:-ml-1 md:mr-2 xl:mr-4'>
                        <img src={'/assets/shared/go-back.svg'} className={'w-[18px] object-contain cursor-pointer'} />
                    </div>
                    <p className='page-title'>Manage Integrations</p>
                </div>
            </div>
            <div className='mt-10 mb-5 flex flex-row justify-center md:justify-end'>
                <Button
                    label={'Add New Integration'}
                    className='btn-primary-rounded-less'
                    onClickButton={onSeeManageModal}
                />
            </div>
            <div className='mb-10'>
                <IntegrationsTable
                    rows={rows}
                    rowsLoading={rowsLoading}
                    onSeeDetails={onSeeIntegrationDetails}
                    paginationData={paginationData}
                    onEditIntegration={onSeeManageModal}
                    setPaginationState={setPaginationState}
                    onDeleteIntegration={onRequestDeleteIntegration}
                />
            </div>
            {showToast?.message &&
                <Toast
                    type={showToast?.type}
                    text={showToast?.message}
                    onHandleCloseToast={() => setShowToast(null)}
                />
            }
            {showIntegrationModal?.show &&
                <IntegrationDetailsModal
                    openModal={showIntegrationModal?.show}
                    data={showIntegrationModal?.data}
                    handleCloseModal={onCloseModal}
                />
            }
            {showManageModal?.show &&
                <ManageIntegrationModal
                    openModal={showManageModal?.show}
                    id={showManageModal?.id}
                    data={showManageModal?.data}
                    onSaveSuccessfully={onSaveChanges}
                    handleCloseModal={onCloseModal}
                />
            }
            <DeleteModal
                openDeleteModal={showDeleteModal?.show || false}
                handleCloseDeleteModal={onCloseDeleteModal}
                onApproveDeletion={onDeleteIntegration}
            />
        </div>
    )
}
export default Integrations;